import gateway from '@interceptors/gateway.interceptor';
import { AccomodationFirstChildrenConverter } from '@converter/accomodationFirstChildrenConverter';
import { CardInfoTranslationConverter } from '@converter/cardInfoTranslationConverter';
import { CardLinkTranslationConverter } from '@converter/cardLinkTranslationConverter';
import { CardSuggestionTranslationConverter } from '@converter/cardSuggestionTranslationConverter';
import { CardTextConverter } from '@converter/cardTextConverter';
import { SponsoredCardTranslationConverter } from '@converter/sponsoredCardTranslationConverter';
import { ContactConverter } from '@converter/contactConverter';
import { LocationConverter } from '@converter/locationConverter';
import { AccomodationTranslationLocationConverter } from '@converter/accomodationTranslationLocationConverter';


class AccomodationService {
    private accomodationFirstChildrenConverter = new AccomodationFirstChildrenConverter();
    private cardInfoTranslationConverter = new CardInfoTranslationConverter();
    private cardTextConverter = new CardTextConverter();
    private sponsoredCardConverter = new SponsoredCardTranslationConverter()
    private cardLinkConverter = new CardLinkTranslationConverter()
    private cardSuggestionConverter = new CardSuggestionTranslationConverter()
    private contactConverter = new ContactConverter()
    private locationConverter = new LocationConverter()
    private accomodationTranslationConverter = new AccomodationTranslationLocationConverter()

    public getAccomodationAndChildrenFromQrCodeId = async (qrCodeId: string) => {
        
        const url = `/no-auth/accomodation/get-accomodation-and-children-from-qrCodeId/${qrCodeId}`;
        const responseDto = await gateway.get(url); 
        const response  = this.accomodationFirstChildrenConverter.dtoToModel(responseDto?.data)
        return response;

    };
    
    public getCardInfoFromIdParent = async (id: number) => {
        
        const url = `/no-auth/card-info/find-all-by-parent/${id}`;
        const responseDto = await gateway.get(url); 
        const response = this.cardInfoTranslationConverter.dtosToModels(responseDto?.data)
        return response

    };

    public getSuggestions = async(qrCodeId: string)=>{
        const url = `/no-auth/accomodation/find-all-active-accomodation-from-qrCodeId/${qrCodeId}` 
        const responseDto = await gateway.get(url)
        const response = this.accomodationTranslationConverter.dtosToModels(responseDto?.data)
        return response
    }

    public getSponsored = async () => {   
        const url = `/no-auth/sponsored-card/find-all`
        const responseDto = await gateway.get(url)
        const response = this.sponsoredCardConverter.dtosToModels(responseDto?.data)
        return response
    };

    public getCardLinkFromIdParent = async (id: number) => {
        
        const url = `/no-auth/card-link/find-all-by-parent/${id}`;
        const responseDto = await gateway.get(url);   
        const response  = this.cardLinkConverter.dtosToModels(responseDto?.data)
        return response;

    };

    public getCardText = async (id: number) => {
        const url = `/no-auth/card-text/find/${id}`;
        const responseDto = await gateway.get(url); 
        const response  = this.cardTextConverter.dtoToModel(responseDto?.data)
        return response;
    }

    public getContact = async (qrCodeId: string) => {
        const url = `/no-auth/contact/find/${qrCodeId}`;
        const responseDto = await gateway.get(url); 
        const response  = this.contactConverter.dtoToModel(responseDto?.data)
        return response;
    }

    public getAccomodationPhotos = (accomodationId: string) => {
        const url = `/no-auth/photo/find-all-by-accomodation-qrCodeId/${accomodationId}`;
        return gateway.get(url);
    }

    public getLocation = async( qrCodeId:string)=>{
        const url = `/no-auth/location/find-all-by-qrCodeId/${qrCodeId}`
        const responseDto = await gateway.get(url)
        const response = this.locationConverter.dtoToModel(responseDto?.data)
        return response
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new AccomodationService();